import { basicEntityFromJson, IBasicEntity, isNullish, Maybe } from "../../../core/models";
import { clientFromJson, IClient } from "../../client/data/entities";
import { expenseFromJson, IExpense } from "../../expense/data/entities";
import { IProduct, productFromJson } from "../../product/data/entities";
import { calcCleanWeight } from "../../product/utils";
import { basicTransactionToJson, IBasicTransaction, IBasicTransactionForm } from "./basic_transaction_entity";
import { ETransactionType } from "./models";
import {
  IProductBuyBulkTransactionForm,
  IProductTransaction,
  productBuyTransactionToJson,
} from "./product_buy_transaction_entity";
import { IProductSellBulkTransactionForm, productSellTransactionToJson } from "./product_sell_transaction_entity";

export interface ITransaction extends IBasicEntity {
  client: Maybe<IClient>;
  amount: number;
  type: ETransactionType;
  product?: IProduct;
  dirtyWeight?: number;
  wastePercent?: number;
  income?: number;
  expense?: IExpense;
  cleanWeight?: number;
  pricePerKg?: number;
}

export const transactionFromJson = (json: any): ITransaction => {
  const cleanWeight =
    !isNullish(json.wastePercent) && !isNullish(json.dirtyWeight)
      ? calcCleanWeight({ dirtyWeight: json.dirtyWeight, wastePercent: json.wastePercent })
      : undefined;
  const amount = parseFloat(json.amount);

  const e: ITransaction = {
    ...basicEntityFromJson(json),
    client: json.client ? clientFromJson(json.client) : undefined,
    product: json.product ? productFromJson(json.product) : undefined,
    amount,
    type: json.type.toString(),
    income: !isNullish(json.income) ? parseFloat(json.income) : undefined,
    expense: json.expense ? expenseFromJson(json.expense) : undefined,
    wastePercent: !isNullish(json.wastePercent) ? parseFloat(json.wastePercent) : undefined,
    dirtyWeight: !isNullish(json.dirtyWeight) ? parseFloat(json.dirtyWeight) : undefined,
    cleanWeight,
    pricePerKg: !isNullish(cleanWeight) ? amount / cleanWeight : undefined,
  };

  return e;
};

export type ITransactionForm = IProductSellBulkTransactionForm | IProductBuyBulkTransactionForm | IBasicTransactionForm;

export const transactionToJson = (form: ITransactionForm) => {
  if (form.type === ETransactionType.PRODUCT_BUY) {
    return productBuyTransactionToJson(form);
  } else if (form.type === ETransactionType.PRODUCT_SELL) {
    return productSellTransactionToJson(form);
  } else {
    return basicTransactionToJson(form);
  }
};

export const isBasicTransaction = (t: ITransaction): t is IBasicTransaction =>
  t.type === ETransactionType.GIVE || t.type === ETransactionType.RECIEVE || t.type === ETransactionType.EXPENSE;

export const isProductTransaction = (t: ITransaction): t is IProductTransaction =>
  t.type === ETransactionType.PRODUCT_BUY || t.type === ETransactionType.PRODUCT_SELL;

export const isLastProductTransaction = (transaction: ITransaction, transactionList: ITransaction[]) => {
  const lastProductTransaction = transactionList.filter(isProductTransaction)[0];
  return lastProductTransaction?.id === transaction.id;
};
